module.exports = __webpack_public_path__ + "img/BUSD-icon.bf4b236d.svg";